import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Keeps the pre-order details (estimated date + disclaimer) in sync with the
 * selected variant. On a variant change the theme re-renders the section and
 * dispatches `variantUpdate` carrying the new HTML; we morph ourselves from the
 * matching <preorder-info> in that HTML. Mirrors the product-inventory pattern.
 *
 * @extends Component
 */
class PreorderInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section, dialog');
    section?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const section = this.closest('.shopify-section, dialog');
    section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = event.detail.data.html.querySelector('preorder-info');
    if (!next) return;

    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('preorder-info')) {
  customElements.define('preorder-info', PreorderInfo);
}
